module.exports = __webpack_public_path__ + "static/media/mobile.3da44784.svg";